import styled from 'styled-components';

export const TagClose = styled.button`
  padding: 0 0 0 2px;
  border: 0;
  background: none;
  color: inherit;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
`;

export const TargetedFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  &[hidden] {
    display: none;
  }
`;
